/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
// @ts-nocheck
import React, { Suspense, lazy } from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    Redirect,
} from "react-router-dom";
import { TypeWriterLoaderVW } from "@vlinder-web/typewriter-loader-widget-react";
import { Root } from "../framework/BugsBunny/src/index";
import { useAuth } from "../services/auth-service/auth.provider";

const { isAuthenticated } = useAuth();

const ProfilePage = lazy(() => import("../pages/Profile"));
const LandingPage = lazy(() => import("../pages/Landing"));
const TrafficLightPage = lazy(() => import("../pages/TrafficLight"));
const LoginPage = lazy(() => import("../pages/Login"));
const TermsPage = lazy(() => import("../pages/TermsandCondition"));
const PrivacyPage = lazy(() => import("../pages/PrivacyPolicy"));

const RouterConfig = (props) => (
    <Switch>
        <PrivateRoute path="/dashboard" component={Root} />
        <Route path="/profile" component={ProfilePage} />
        <Route path="/traffic-light" component={TrafficLightPage} />
        <Route path="/creds" component={LoginPage} />
        <Route path="/login" component={LoginPage} />
        <Route exact path="/terms" component={TermsPage} />
        <Route exact path="/privacy" component={PrivacyPage} />
        <Route path="/" component={LandingPage} />
    </Switch>
);
const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={(props) =>
            isAuthenticated() ? (
                <Component {...props} />
            ) : (
                <Redirect
                    to={{
                        pathname: `/`,
                    }}
                />
            )
        }
    />
);

function RouteWithSubRoutes(route) {
    return (
        <Route
            path={route.path}
            render={(props) => (
                // pass the sub-routes down to keep nesting
                <route.component {...props} routes={route.routes} />
            )}
        />
    );
}

export const AppNavigator = (): JSX.Element => {
    return (
        <Router>
            <Suspense fallback={<TypeWriterLoaderVW />}>
                <RouterConfig />
            </Suspense>
        </Router>
    );
};
